import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useOutstandingCreditNoteList } from "../../state/outstandingCreditNoteListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { TableFilterBar } from "../../components/TableFilterBar";
import { CreditNoteTable } from "../../components/CreditNoteTable";
// MUI Imports
import Typography from "@mui/material/Typography";

export default function OutstandingCreditNoteList() {
  // List of credit memos
  const [creditNoteList, setCreditNoteList] = useState({
    filter: {},
    crmemo: [],
    paging: {},
  });

  // Filter defaults
  const [filter, setFilter] = useUrlFilterState(
    {
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["pageSize"] },
  );

  // Fetch list of credit Notes
  const { isError, data, error, isFetching, isSuccess } =
    useOutstandingCreditNoteList(filter);

  // Success Function
  const successFunc = () => {
    setCreditNoteList(data.data.data.data.list);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={"Outstanding Credit Notes"} />
      <TableFilterBar
        filter={filter}
        setFilter={setFilter}
        invalidateQuery={["creditMemoListState"]}
      />
      {isError && <Typography>Error: {error.message}</Typography>}
      <CreditNoteTable
        data={creditNoteList}
        loading={isFetching}
        filter={filter}
        setFilter={setFilter}
        type={"outstanding"}
      />
    </>
  );
}
